import { NgModule, provideBrowserGlobalErrorListeners, LOCALE_ID, DEFAULT_CURRENCY_CODE, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideToastr } from 'ngx-toastr';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localePt);

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { CoreModule } from '@core/core.module';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { TenantService } from '@core/tenant/tenant.service';
import { AuthService } from '@shared/services/auth.service';
import { UserPermissionsService } from '@shared/services/user-permissions.service';
import { firstValueFrom } from 'rxjs';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { authInterceptor } from '@core/interceptors/auth.interceptor';

import { MAT_DATE_LOCALE } from '@angular/material/core';

@NgModule({
  declarations: [
    App
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    TranslateModule.forRoot()
  ],
  providers: [
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor]), withInterceptorsFromDi()),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'pt-BR'
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'BRL'
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [TenantService],
      useFactory: (tenantService: TenantService) => () => tenantService.initialize()
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AuthService, UserPermissionsService],
      useFactory:
        (authService: AuthService, userPermissionsService: UserPermissionsService) => () => {
          if (!authService.isAuthenticated()) return Promise.resolve();
          return firstValueFrom(userPermissionsService.load()).catch(() => undefined);
        }
    }
  ],
  bootstrap: [App]
})
export class AppModule { }


